import { render, staticRenderFns } from "./ModalView.vue?vue&type=template&id=9ddbfdc0&scoped=true"
import script from "./ModalView.vue?vue&type=script&lang=js"
export * from "./ModalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddbfdc0",
  null
  
)

export default component.exports